var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 46,
    viewBox: "0 0 264 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 13.0843V18.5242H87.6666V37.0404H94.1687V18.5242H100.875V13.0843H80.96ZM173.565 12.8799H173.088C163.744 12.8799 161.968 18.2876 161.968 25.0624C161.968 31.8371 163.748 37.2448 173.088 37.2448H173.565C182.91 37.2448 184.686 31.8371 184.686 25.0624C184.686 18.2876 182.906 12.8799 173.565 12.8799ZM173.874 31.805H172.78C170.623 31.805 168.466 30.6746 168.466 25.0624C168.466 19.4502 170.623 18.3197 172.78 18.3197H173.874C176.063 18.3197 178.187 19.4502 178.187 25.0624C178.187 30.6746 176.067 31.805 173.874 31.805ZM149.164 31.805H148.07C145.913 31.805 143.757 30.6746 143.757 25.0624C143.757 19.4502 145.913 18.3197 148.07 18.3197H149.164C150.976 18.3197 152.756 18.937 153.305 22.3244H159.499C159.054 17.1211 157.102 12.8799 148.856 12.8799H148.379C139.034 12.8799 137.258 18.2876 137.258 25.0624C137.258 31.8371 139.038 37.2448 148.379 37.2448H148.856C157.102 37.2448 159.054 32.9996 159.499 27.8003H153.305C152.756 31.1877 150.976 31.805 149.164 31.805ZM133.935 37.0404V13.0843H127.433V37.0404H133.935ZM119.492 29.9209C122.538 28.4818 123.565 24.8218 123.565 21.8794C123.565 18.1153 121.921 13.1204 116.585 13.0843H103.273V37.0404H109.775V30.5703H112.685L113.779 32.3502C115.832 35.6694 117.439 37.4132 121.208 37.4132C122.202 37.4132 123.328 37.2769 124.663 37.0364L119.496 29.9169L119.492 29.9209ZM114.188 25.0944H109.775V18.5242H114.188C115.832 18.5242 116.79 19.5504 116.79 21.9115C116.79 24.2726 115.728 25.0944 114.188 25.0944Z",
    fill: "url(#paint0_linear_86_578)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.233 13.0845C204.196 13.0845 203.134 14.692 202.176 17.7747L200.087 24.4492L197.999 17.7747C197.041 14.696 196.015 13.0845 191.942 13.0845H188.073V37.0406H194.575V24.822L196.083 29.9211C197.041 33.104 197.382 33.9258 199.883 33.9258H200.328C202.793 33.9258 203.17 33.104 204.128 29.9211L205.635 24.822V37.0406H212.138V13.0845H208.237H208.233ZM263.193 13.0845H256.073L251.383 21.8435L246.693 13.0845H239.541L246.384 25.0625L239.541 37.0406H246.693L251.383 28.2775L256.073 37.0406H263.193L256.35 25.0625L263.193 13.0845ZM230.718 13.0845C225.174 13.0845 223.703 14.3151 221.514 19.5866L214.294 37.0406H221.205L222.813 33.0719H230.718V37.0406H237.152V13.0845H230.718ZM230.718 27.6281H225.038L226.85 23.1784C228.08 20.1679 229.211 18.7648 230.718 18.5564V27.6241V27.6281Z",
    fill: "#264796"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7786 5.63117C38.6954 5.49325 38.7398 5.31371 38.878 5.23049C39.0159 5.14728 39.1954 5.19171 39.2787 5.32989L45.3363 15.3525C45.9214 16.3208 46.3617 17.352 46.6565 18.4259C46.9552 19.5131 47.1044 20.6393 47.1044 21.7838C47.1044 25.2358 45.7049 28.3616 43.4424 30.6241C41.1798 32.8867 38.054 34.2862 34.602 34.2862C31.1498 34.2862 28.0243 32.8864 25.7617 30.6241C23.4992 28.3616 22.0996 25.2358 22.0996 21.7838C22.0996 20.644 22.2543 19.5164 22.5568 18.4282C22.8586 17.3425 23.3073 16.2989 23.8958 15.3252L29.948 5.31114C30.0312 5.17296 30.2105 5.12853 30.3487 5.21175C30.4869 5.29496 30.5313 5.47424 30.4481 5.61242L24.3961 15.6265C23.8333 16.5576 23.4057 17.5521 23.1188 18.5836C22.8314 19.6176 22.6845 20.6933 22.6845 21.7838C22.6845 25.0745 24.0188 28.0539 26.1755 30.2109C28.3322 32.3676 31.3119 33.7019 34.6026 33.7019C37.8932 33.7019 40.8729 32.3676 43.0296 30.2109C45.1863 28.0542 46.5206 25.0745 46.5206 21.7838C46.5206 20.6858 46.3791 19.6109 46.0956 18.5789C45.8159 17.5611 45.3964 16.5797 44.8368 15.6537L38.7794 5.63117H38.7786Z",
    fill: "url(#paint1_linear_86_578)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.602 2.0791L25.8742 16.5207C24.9457 18.0569 24.4115 19.8581 24.4115 21.7842C24.4115 27.4121 28.9738 31.9747 34.602 31.9747C40.23 31.9747 44.7926 27.4124 44.7926 21.7842C44.7926 19.8581 44.2584 18.0569 43.3299 16.5207L34.602 2.0791Z",
    fill: "url(#paint2_linear_86_578)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6632 32.4353L14.75 36.1824L20.2059 41.6359L23.9502 38.7225C25.8311 39.9081 27.9233 40.7894 30.1571 41.2964L30.745 46H38.4591L39.047 41.2964C41.2808 40.7894 43.373 39.9081 45.2539 38.7225L48.9981 41.6359L54.454 36.1824L51.5409 32.4353C52.726 30.5552 53.6067 28.4642 54.114 26.2317L58.8224 25.6451L60.7739 20.8239C56.8139 21.729 52.8539 22.6343 48.8939 23.5397C48.0275 30.6623 41.9578 36.1818 34.6018 36.1818C27.2458 36.1818 21.176 30.6623 20.3094 23.5397C16.3494 22.6343 12.3894 21.729 8.42936 20.8239L10.3809 25.6451L15.0896 26.2317C15.5969 28.4642 16.4773 30.5552 17.6627 32.4353H17.6632Z",
    fill: "#264796"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3334 8.84263L69.2038 0L63.2158 14.7927L48.9689 20.829C48.8178 18.538 48.1246 16.3194 46.9308 14.344L39.5424 2.11896L48.3334 8.84263ZM20.8704 8.84263L0 0L5.98806 14.7927L20.2349 20.829C20.386 18.538 21.0792 16.3194 22.2728 14.344L29.6611 2.11896L20.8701 8.84263H20.8704Z",
    fill: "url(#paint3_linear_86_578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_578",
    x1: 86.7807,
    y1: 37.0404,
    x2: 86.7847,
    y2: 23.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_86_578",
    x1: 22.685,
    y1: 32.3322,
    x2: 22.685,
    y2: 7.29501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_86_578",
    x1: 35.0746,
    y1: 8.43907,
    x2: 35.0752,
    y2: 25.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7F1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_86_578",
    x1: 20.2352,
    y1: 20.829,
    x2: 20.2355,
    y2: 8.84263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060AA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.72eab81141f883a5eb447ffe745cdc83.svg";
export { ForwardRef as ReactComponent };